exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.export-homecare-btn-area[data-v-3ff76f18] {\n  width: 130px;\n  height: 31px;\n  margin: 20px 0 0 5px;\n}\n.export-homecare-btn[data-v-3ff76f18] {\n  padding: 0 20px;\n  background-color: #FF8EA1;\n  color: white;\n  font-size: 12px;\n  width: 130px;\n  line-height: 30px;\n  border-radius: 15px;\n  text-align: center;\n}\n.export-homecare-btn[data-v-3ff76f18]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports
